module.exports = __webpack_public_path__ + "static/media/solution-super-banner.93c0e0c7.jpg";